import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-217bb795"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: "kefu",
    style: _normalizeStyle({
      width: $data.position.kefuWidth + 'px',
      top: $data.position.y + 'px',
      left: $data.position.x + 'px'
    }),
    id: "floatball",
    onMousedown: _cache[1] || (_cache[1] = (...args) => $options.down && $options.down(...args)),
    onTouchstart: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.down && $options.down(...args), ["stop"])),
    onMousemove: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.move && $options.move(...args), ["prevent"])),
    onTouchmove: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.move && $options.move(...args), ["prevent"])),
    onMouseup: _cache[5] || (_cache[5] = (...args) => $options.end && $options.end(...args)),
    onTouchend: _cache[6] || (_cache[6] = _withModifiers((...args) => $options.end && $options.end(...args), ["stop"]))
  }, [_createElementVNode("img", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goCustomerService && $options.goCustomerService(...args)),
    class: _normalizeClass($data.kfImgFlag ? 'kefu1' : 'kefuLeft'),
    src: $data.kfImg,
    alt: ""
  }, null, 10, _hoisted_1)], 36)]);
}